<ng-container *ngIf="options$ | async as options">
    <div
        class="sb-modal-grid"
        #modalContainer
        [ngClass]="
            viewportSize === 'xs' ? 'sb-modal-center' : 'sb-modal-' + options.position
        "
        [@fadeInOutModal]="{
        value: 'transform',
        params: {
            modalFadeOutTransform: (modalFadeTransform$ | async),
        }
    }"
        (@fadeInOutModal.done)="onFadeAnimationEnd($event)"
    >
        <section
            #modalWrapper
            role="dialog"
            aria-modal="true"
            aria-label="Application modal window"
            class="sb-modal-grid-container"
            [ngClass]="options.size ? 'sb-modal-' + options.size : 'sb-modal-xs'"
        >
            <header
                (panup)="onPanUp($event)"
                (pandown)="onPanDown($event)"
                (panend)="onPanEnd($event)"
                (swipedown)="onSwipeDown($event)"
                (tap)="onHeaderTap($event)"
                class="sb-modal-grid-header"
                [class.non-standalone]="!options.isStandalone"
                #modalHeader
            >
                <ng-container *ngIf="viewportSize === 'xs' && options.allowDragResize">
                    <span class="sb-modal-drag-indicator"></span>
                </ng-container>
                <h2 class="mb-0">{{ options.modalTitle }}</h2>
                <ng-container *ngIf="options.isStandalone || !options.defaultCloseAction">
                    <button
                        type="button"
                        class="btn close"
                        (click)="closeModal()"
                    ></button>
                </ng-container>
            </header>
            <main class="sb-modal-grid-body">
                <ng-content
                    *ngIf="!options.templateRef; else templatePortal"
                ></ng-content>
            </main>
            <footer
                class="sb-modal-grid-footer row gy-3 align-items-center text-center text-sm-right"
            >
                <div class="col-12">
                    <button
                        type="button"
                        class="btn secondary"
                        (click)="closeModal()"
                        *ngIf="!(options.defaultCloseAction === false)"
                    >
                        {{ options.closeButtonText }}
                    </button>
                    <ng-container *ngIf="options.footerActions">
                        <ng-container
                            *ngFor="let action of options.footerActions; let i = index"
                            [ngTemplateOutlet]="action"
                            [ngTemplateOutletContext]="{ $index: i }"
                        ></ng-container>
                    </ng-container>
                </div>
            </footer>
        </section>
        <div
            *ngIf="options.isStandalone || options.hasBackdrop"
            class="backdrop"
            #backdropElement
        ></div>
    </div>
    <ng-template #templatePortal>
        <ng-container [ngTemplateOutlet]="(options$ | async).templateRef"></ng-container>
    </ng-template>
</ng-container>
